<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <RouterLink class="brand-logo">
      <vona-logo />
      <h2 class="brand-text text-primary ml-1">
        {{ getAssociation }}
      </h2>
    </RouterLink>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">Página não encontrada 🕵🏻‍♀️</h2>
        <p class="mb-2">
          Certifique-se da validade da requisição e tente novamente.
        </p>

        <b-button variant="primary" class="mb-2 btn-sm-block" href="/">
          Voltar para a página principal
        </b-button>

        <!-- image -->
        <b-img fluid :src="imgUrl" alt="Error page" />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import store from "@/store/index";
import VonaLogo from "@core/layouts/components/Logo.vue";
import { BButton, BImg } from "bootstrap-vue";
import { RouterLink } from "vue-router";

export default {
  components: {
    VonaLogo,
    RouterLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/error.svg"),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/error-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    },
    getAssociation() {
      return localStorage.getItem("domain") || "Vona";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
